import { ProgressSpinner } from "primereact/progressspinner";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Select from "react-select";
import FormValidation from "../../../Common/FormValidation";
import Http from "../../../Common/Http";
import IsLogin from "../../../Common/IsLogin";

const Create = () => {
  const navigate = useNavigate();
  const { type } = useParams();
  const [inputs, setInputs] = useState({ type, mushok_6_4_show: true }); // initialized type from useParams
  const [unit, setUnit] = useState([]);
  const [unitSupply, setUnitSupply] = useState([]);
  const [category, setCategory] = useState([]);
  const [kitchen, setKitchen] = useState([]);
  const [error, setError] = useState({});
  const [allowConversion, setAllowConversion] = useState(false);
  const [showAccountsForm, setShowAccountsForm] = useState(false);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setLoading(true);
    if (inputs.type === "finished_goods") {
      setShowAccountsForm(true);
    } else {
      setShowAccountsForm(false);
    }

    const fetchData = async () => {
      try {
        const unitData = await Http.get("/active-unit");
        const categoryData = await Http.get("/product-active");
        const kitchenData = await Http.get("/kitchen-staff");
        const codeData = await Http.get(
          "/last-code-increment-by-one/products/code/P"
        );

        setUnit(unitData.data);
        setUnitSupply(unitData.data);
        setCategory(categoryData.data);
        setKitchen(kitchenData.data);
        setInputs((prevInputs) => ({
          ...prevInputs,
          code: codeData.data,
        }));
      } catch (error) {
        console.error("Fetch error:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const selectHandleChange = (selectedOption, actionMeta) => {
    const name = actionMeta.name;
    const value = selectedOption.value;
    setInputs((values) => ({ ...values, [name]: value }));

  };

  const handleChange = (e) => {
    const name = e.target.name;
    const value =
      e.target.type === "checkbox" ? e.target.checked : e.target.value;

    setInputs((values) => {
      let updatedInputs = { ...values, [name]: value };

      if (name === "type") {
        updatedInputs = {
          ...updatedInputs,
          ac: "",
          non_ac: "",
          staff: "",
          others: ""
        };

        if (value === "finished_goods") {
          setAllowConversion(true);
        } else {
          setAllowConversion(false);
        }
      }

      return updatedInputs;
    });
  };

  // const formSubmit = () => {
  //   // Apply default values before submission
  //   const submissionData = {
  //     ...inputs,
  //     // Set unit_id to first available unit if not selected
  //     unit_id: inputs.unit_id || (unit.length > 0 ? unit[0].value : null),
  //     // Set type to 'raw_materials' if not selected
  //     type: inputs.type || 'raw_materials',
  //     // Set category_id to first available category if not selected
  //     category_id: inputs.category_id || (category.length > 0 ? category[0].value : null)
  //   };

  //   Http.post("/product", submissionData)
  //     .then((res) => {
  //       navigate("/product", {
  //         state: { message: res.data.message, type: "success" },
  //       });
  //     })
  //     .catch(function (e) {
  //       setError(e.response.data.errors);
  //     });
  // };

  const formSubmit = () => {
    if (!validateFinishedGoods()) return;

    const submissionData = {
      ...inputs,
      unit_id: inputs.unit_id || (unit.length > 0 ? unit[0].value : null),
      type: inputs.type || "raw_materials",
      category_id:
        inputs.category_id || (category.length > 0 ? category[0].value : null),
    };
    if (inputs.type === "finished_goods") {
      submissionData.ac = inputs.ac || 0;
      submissionData.non_ac = inputs.non_ac || 0;
      submissionData.staff = inputs.staff || 0;
      submissionData.others = inputs.others || 0;
    }

    Http.post("/product", submissionData)
      .then((res) => {
        navigate("/product", {
          state: { message: res.data.message, type: "success" },
        });
      })
      .catch((e) => {
        setError(e.response.data.errors);
      });
  };


  const validateFinishedGoods = () => {
    if (inputs.type === "finished_goods") {
      let errors = {};

      if (!inputs.ac) errors.ac = "AC is required";
      if (!inputs.non_ac) errors.non_ac = "Non AC is required";
      if (!inputs.staff) errors.staff = "Staff is required";
      if (!inputs.others) errors.others = "Others is required";

      if (Object.keys(errors).length > 0) {
        setError(errors);
        return false;
      }
    }
    return true;
  };

  return (
    <div>
      <IsLogin></IsLogin>
      {/* <LoaderComponent /> */}
      <div className="am-mainpanel">
        <div className="am-pagetitle">
          <h5 className="am-title">Create Product</h5>
        </div>
        <div className="am-pagebody">
          <div className="card pd-20 pd-sm-40">
            <h6 className="card-body-title mg-sm-b-30">Create Product Form</h6>
            <div className="row">
              <div className="col-lg">
                <FormValidation error={error} />
              </div>
            </div>
            {loading ? (
              <ProgressSpinner />
            ) : (
              <>
                <div className="row">
                  <div className="col-lg">
                    <label>
                      Code <i className="fa fa-star required"></i>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="code"
                      value={inputs.code || ""}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-lg">
                    <label>
                      Name <i className="fa fa-star required"></i>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="name"
                      value={inputs.name || ""}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-lg">
                    <label htmlFor="">
                      Unit <i className="fa fa-star required"></i>
                    </label>
                    <Select
                      className="basic-single"
                      classNamePrefix="select"
                      defaultValue={unit[0]}
                      name="unit_id"
                      options={unit}
                      onChange={selectHandleChange}
                    />
                  </div>
                  <div className="col-lg">
                    <label>
                      Price <i className="fa fa-star required"></i>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="price"
                      value={inputs.price || ""}
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="col-lg">
                    <label>
                      SKU
                      {/* <i className="fa fa-star required"></i> */}
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="sku"
                      value={inputs.sku || ""}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-lg">
                    <label>Pack Size</label>
                    <input
                      type="text"
                      className="form-control"
                      name="pack_size"
                      value={inputs.pack_size || ""}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-lg">
                    <label>
                      Type <i className="fa fa-star required"></i>
                    </label>
                    <select
                      className="form-control"
                      name="type"
                      value={inputs.type}
                      onChange={handleChange}
                    >
                      <option value="">Select Type</option>
                      <option value="raw_materials">Raw Materials</option>
                      <option value="packing_materials">
                        Packing Materials
                      </option>
                      <option value="finished_goods">Finished Goods</option>
                    </select>
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="col-lg">
                    <label htmlFor="">
                      Category <i className="fa fa-star required"></i>
                    </label>
                    <Select
                      className="basic-single"
                      classNamePrefix="select"
                      defaultValue={category[0]}
                      name="category_id"
                      options={category}
                      onChange={selectHandleChange}
                    />
                  </div>
                  <div className="col-lg">
                    <label>Kitchen</label>
                    <Select
                      className="basic-single"
                      classNamePrefix="select"
                      name="kitchen_id"
                      options={kitchen}
                      onChange={selectHandleChange}
                    />
                  </div>
                  <div className="col-lg">
                    <label>Notes</label>
                    <textarea
                      className="form-control"
                      name="notes"
                      value={inputs.notes || ""}
                      onChange={handleChange}
                    ></textarea>
                  </div>
                  <div className="col-lg">
                    <label>Status</label>
                    <select
                      className="form-control"
                      name="status"
                      onChange={handleChange}
                    >
                      <option value="">Select Status</option>
                      <option value="active">Active</option>
                      <option value="inactive">Inactive</option>
                    </select>
                  </div>
                </div>

                {allowConversion && (
                  <div className="row mt-3">
                    <div className="col-12">
                      <h6 className="card-body-title mg-sm-b-30">Conversion Details (Required for Finished Goods)</h6>
                    </div>
                    <div className="col-lg">
                      <label>
                        AC <i className="fa fa-star required"></i>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="ac"
                        value={inputs.ac || ""}
                        onChange={handleChange}
                        placeholder="Enter AC conversion factor"
                      />
                    </div>
                    <div className="col-lg">
                      <label>Non AC <i className="fa fa-star required"></i></label>
                      <input
                        type="text"
                        className="form-control"
                        name="non_ac"
                        value={inputs.non_ac || ""}
                        onChange={handleChange}
                        placeholder="Enter Non AC conversion factor"
                      />
                    </div>
                    <div className="col-lg">
                      <label>Staff <i className="fa fa-star required"></i></label>
                      <input
                        type="text"
                        className="form-control"
                        name="staff"
                        value={inputs.staff || ""}
                        onChange={handleChange}
                        placeholder="Enter Staff conversion factor"
                      />
                    </div>
                    <div className="col-lg">
                      <label>Others <i className="fa fa-star required"></i></label>
                      <input
                        type="text"
                        className="form-control"
                        name="others"
                        value={inputs.others || ""}
                        onChange={handleChange}
                        placeholder="Enter Others conversion factor"
                      />
                    </div>
                  </div>
                )}


                <div className="row mt-3">
                  <div className="col-3">
                    <button
                      className="btn btn-primary btn-block mg-b-10"
                      onClick={formSubmit}
                    >
                      <i className="fa fa-send mg-r-10"></i> Create
                    </button>
                  </div>
                </div>
              </>
            )}
          </div>
          {/* card */}
        </div>
      </div>
    </div>
  );
};

export default Create;
